"use client";

import {
  __objRest,
  __spreadProps,
  __spreadValues,
  lineColorVar,
  pathCss,
  spinnerCss,
  spinnerSizeCss,
  spinnerSvgCss
} from "./chunk-7662VWRS.mjs";

// src/Spinner.tsx
import {
  mapResponsive,
  useBreakpointContext
} from "@teamsparta/stack-core";
import { Flex } from "@teamsparta/stack-flex";
import { vars } from "@teamsparta/stack-tokens";
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
var Spinner = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      size = "lg",
      color = vars.spinner.indicator.color,
      loading = true,
      style: styleFromProps,
      children
    } = _b, restProps = __objRest(_b, [
      "size",
      "color",
      "loading",
      "style",
      "children"
    ]);
    const breakpoints = useBreakpointContext("Spinner");
    if (!loading) {
      return /* @__PURE__ */ jsx(Fragment, { children });
    }
    const sizes = mapResponsive(breakpoints, size, (breakpoint, value) => ({
      breakpoint,
      size: value
    }));
    const style = __spreadValues({
      [lineColorVar]: color
    }, styleFromProps);
    const spinner = /* @__PURE__ */ jsx(
      "span",
      __spreadProps(__spreadValues({
        ref,
        css: [spinnerSizeCss(sizes), spinnerCss],
        style
      }, restProps), {
        children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", css: spinnerSvgCss, fill: "none", children: /* @__PURE__ */ jsx("circle", { css: pathCss, fill: "none", strokeLinecap: "round" }) })
      })
    );
    if (children === void 0) {
      return spinner;
    }
    return /* @__PURE__ */ jsxs(
      Flex,
      {
        as: "span",
        align: "center",
        justify: "center",
        style: { position: "relative" },
        children: [
          /* @__PURE__ */ jsx("span", { "aria-hidden": true, style: { display: "contents", visibility: "hidden" }, children }),
          /* @__PURE__ */ jsx(
            Flex,
            {
              align: "center",
              justify: "center",
              style: { position: "absolute", inset: 0 },
              children: spinner
            }
          )
        ]
      }
    );
  }
);
Spinner.displayName = "Spinner";

export {
  Spinner
};
